import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import Field from 'containers/Field';
import RawHtml from 'common/RawHtml';
import Spinner from 'common/Spinner';
import dialogActions from 'core/dialogs/actions';
import Button from 'common/Button';

import headerStyles from './styles/header';
import titleStyles from './styles/title';
import contentWrapperStyles from './styles/contentWrapper';
import dialogStyles from './styles/dialog';
import contentStyles from './styles/content';
import bodyStyles from './styles/body';

const styles = (theme) => {
  const common = {
    body: bodyStyles(theme),
    content: contentStyles(theme),
    contentWrapper: {
      ...contentWrapperStyles(theme),
      '& .col-sm-12': {
        margin: [0, 'auto'],
        maxWidth: 435,
      },
      '& p': {
        margin: [0, 'auto'],
        maxWidth: 475,
        textAlign: 'center',
        [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
          textAlign: 'left',
        },
      },
      [`@media(max-width: ${theme.screenSizes.mobileMax}px)`]: {
        padding: 20,
      },
    },
    dialog: dialogStyles(theme),
    header: headerStyles(theme),
    title: titleStyles(theme),
  };

  return {
    ...common,
    buttonRow: {
      padding: [55, 10, 0, 10],
      textAlign: 'center',
    },
    footer: {
      display: 'none',
    },
  };
};

export const VerifyUserBare = ({
  cancelButtonLabel,
  classes,
  commonClasses,
  confirmButtonLabel,
  errorMsg,
  hasSelectedValue,
  loading,
  primaryAction,
  secondaryAction,
  verifyPopupAreaText,
  verifyPopupTitle,
}) => {
  const buttons = [
    {
      className: classnames('btn btn-mobile btn-i-accept', { loading }),
      disabled: loading || !hasSelectedValue,
      onClick: primaryAction,
      text: confirmButtonLabel,
      variant: 'primary',
    },
    {
      className: 'btn btn-mobile btn-mobile--secondary btn-i-decline',
      disabled: loading,
      onClick: secondaryAction,
      text: cancelButtonLabel,
      variant: 'secondary',
    },
  ];
  return (
    <div className={classnames('modal-verify-verifyUser', commonClasses, classes.dialog)}>
      <div className={classnames('modal-content', classes.content)}>
        <div className={classnames('modal-header', classes.header)}>
          <RawHtml type="h4" className={classnames(classes.title, 'modal-title')} id="modal-title">
            {verifyPopupTitle}
          </RawHtml>
        </div>
        <div className="error-region">{errorMsg}</div>
        <div className={classnames('modal-body', classes.body)} id="modal-body">
          <div
            className={classnames(
              'modal-content-wrapper verify-verifyUser',
              classes.contentWrapper,
            )}
          >
            <RawHtml type="p">{verifyPopupAreaText}</RawHtml>
            <div className="row">
              <div className="widget">
                <div className="region-groups">
                  <Field fieldName="appRequest_customer_mfa" groupName="TWO_FACTOR_AUTH" />
                </div>
              </div>
            </div>
            <div className={classnames('verifyUser-btn-group', classes.buttonRow)}>
              {buttons.map((b, i) => (
                <Button
                  /* eslint-disable-next-line react/no-array-index-key */
                  key={`dialog-button-${i}`}
                  data-key={i}
                  {...b}
                >
                  {b.text}
                  {b.className.includes('btn-i-accept') && (
                    <>
                      <i className="icon-arrow-thin-right" aria-hidden="true" />
                      <Spinner loading={loading} />
                    </>
                  )}
                </Button>
              ))}
            </div>
          </div>
        </div>
        <div className={classnames('modal-footer', classes.footer)} />
      </div>
    </div>
  );
};

VerifyUserBare.propTypes = {
  cancelButtonLabel: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  commonClasses: PropTypes.string.isRequired,
  confirmButtonLabel: PropTypes.string.isRequired,
  errorMsg: PropTypes.string,
  hasSelectedValue: PropTypes.bool,
  loading: PropTypes.bool,
  primaryAction: PropTypes.func.isRequired,
  secondaryAction: PropTypes.func.isRequired,
  verifyPopupAreaText: PropTypes.string,
  verifyPopupTitle: PropTypes.string,
};

VerifyUserBare.defaultProps = {
  errorMsg: '',
  hasSelectedValue: false,
  loading: false,
  verifyPopupAreaText: PropTypes.string,
  verifyPopupTitle: PropTypes.string,
};

const mapStateToProps = ({ data, dialogs, page, resources, ui }) => ({
  cancelButtonLabel: resources.mfaActionCancelLabel,
  confirmButtonLabel: resources.mfaActionNextLabel,
  errorMsg: dialogs.params && dialogs.params.errorMsg,
  hasSelectedValue: !!data.appRequest_customer_mfa,
  loading: ui.pageLoading,
  pageName: page.name,
  verifyPopupAreaText: resources.mfaPopupAreaText,
  verifyPopupTitle: resources.mfaPopupTitle,
});

const mapDispatchToProps = {
  primaryAction: dialogActions.sendCode,
  secondaryAction: dialogActions.close,
};

const VerifyUserStyled = withStyles(styles)(VerifyUserBare);

export default connect(mapStateToProps, mapDispatchToProps)(VerifyUserStyled);
